function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M33.5322,32c0-2.2088-1.7888-4-4-4H13.0634l19.426-21.3048c1.0664-1.1716,1.3436-2.8612,0.7032-4.3104   C32.5518,0.9356,31.1183,0,29.5322,0H4.001c-2.2107,0-4,1.7912-4,4s1.7893,4,4,4h16.4688L1.0442,29.3048   c-1.0664,1.1716-1.344,2.8612-0.7032,4.3104C0.9814,35.0644,2.415,36,4.001,36h25.5312C31.7434,36,33.5322,34.2088,33.5322,32z",
  fill: "#343434"
}), React.createElement("path", {
  d: "M48.001,28h16.4688L45.0442,49.3048c-1.0664,1.1716-1.344,2.8612-0.7032,4.3104   C44.9814,55.0644,46.415,56,48.001,56h25.5312c2.2112,0,4-1.7912,4-4s-1.7888-4-4-4H57.0634l19.426-21.3048   c1.0664-1.1716,1.3436-2.8612,0.7032-4.3104C76.5518,20.9356,75.1183,20,73.5322,20H48.001c-2.2107,0-4,1.7912-4,4   S45.7903,28,48.001,28z",
  fill: "#343434"
}), React.createElement("path", {
  d: "M41.5206,88c0-2.2088-1.7892-4-4-4h-7.676l10.8008-13.502c0.9612-1.1992,1.1449-2.8456,0.4809-4.2304   C40.4583,64.8808,39.0598,64,37.5206,64h-16c-2.2108,0-4,1.7912-4,4s1.7892,4,4,4h7.6756L18.3954,85.502   c-0.9608,1.1992-1.1444,2.8456-0.4804,4.2304C18.583,91.1192,19.9814,92,21.5206,92h16C39.7314,92,41.5206,90.2088,41.5206,88z",
  fill: "#343434"
}), React.createElement("path", {
  d: "M155.3331,49.3632c-7.4844-5.242-15.6756-9.242-24.3436-11.8904c-1.6604-0.508-3.4532,0.1092-4.4452,1.5312   c-0.9924,1.42-0.9612,3.3184,0.0821,4.7012c20.5,27.2204,21.1287,64.2812,1.5663,92.2204   c-19.5588,27.9396-54.586,40.0296-87.1956,30.0648c-1.656-0.508-3.4528,0.1092-4.4452,1.5312   c-0.992,1.42-0.9608,3.3184,0.082,4.7012c5.4492,7.236,12.0116,13.5644,19.504,18.8124   c15.0624,10.5468,32.3476,15.6092,49.4765,15.6072c27.2811-0.0016,54.1563-12.8496,70.9571-36.8436   C203.9191,130.742,194.3918,76.7128,155.3331,49.3632z",
  fill: "#343434"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 192.1797 206.6424",
    id: "sleep",
    version: 1.1,
    viewBox: "0 0 192.1797 206.6424",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-sleep.cec480be.svg";
export { SvgComponent as ReactComponent };